/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { notificationActualConfig } from '../../config/notifications.config';

export interface IStaticActualPagePluginMethods extends IPluginMethodMap {
  getStaticActualPageSync(): any;
}

export class StaticActualPagePlugin implements IAgentPlugin {
  readonly methods: IStaticActualPagePluginMethods;

  constructor() {
    this.methods = {
      getStaticActualPageSync: this.getStaticActualPageSync.bind(this),
    };
  }

  getStaticActualPageSync() {
    return {
      notifications: notificationActualConfig,
    };
  }
}
